import { render } from "./AlmacenForm.vue?vue&type=template&id=d05b494a&scoped=true"
import script from "./AlmacenForm.vue?vue&type=script&lang=js"
export * from "./AlmacenForm.vue?vue&type=script&lang=js"

import "./AlmacenForm.vue?vue&type=style&index=0&id=d05b494a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d05b494a"]])

export default __exports__